/**
 * View-Landmark. Will be triggered if element can be found in the DOM.
 * @param {HTMLElement} element Element which posesses this landmark.
 * @param {object} data Landmark configuration data. Cannot be null.
 * @param {function} sendLandmark Function to send data to the landmark service. Cannot be null.
 */

export default function(element, data, sendLandmark) {
    // Only send landmark if element is visible
    if(isVisible(element)) {
        data.landmark = data.landmark || 'action';
        sendLandmark(data);
    }
}

// taken from jQuery code for :visible
// will trigger for visiblibity:hidden though (not sure if this is expected/wanted)
// same behaviour as in webshop though
function isVisible(element) {
    return !!( element.offsetWidth || element.offsetHeight || element.getClientRects().length );
}